import { Box, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import SideNav from '../../common/SideNav';
// import LoyaltyConfig from './LoyaltyConfig';
import PrizeList from './PrizeList';
import RewardList from './RewardList';

const ManageRewards = () => {
    const [tabIndex, setTabIndex] = useState(0);

    return (
        <div>
            <div className="component-container-root">
                <SideNav />
                <Box className="manage-events-container component-container">
                    <p className="instruction">
                        View and manage the rewards of the loyalty program. Go
                        to '<Link to="/help">Help page</Link>' for information
                        on how to manage.
                    </p>
                    <Box sx={{ p: 3 }}>
                        <Tabs
                            value={tabIndex}
                            onChange={(e, newIndex) => setTabIndex(newIndex)}
                        >
                            <Tab label="Prize" sx={{ color: 'black' }} />
                            <Tab label="Promotions" sx={{ color: 'black' }} />
                            {/* <Tab label="Config" sx={{ color: 'black' }} /> */}
                        </Tabs>

                        {tabIndex === 0 && <PrizeList />}

                        {tabIndex === 1 && <RewardList />}
                        {/* {tabIndex === 2 && <LoyaltyConfig />} */}
                    </Box>
                </Box>
            </div>
        </div>
    );
};
export default ManageRewards;
